import { useEffect, useState } from "react";
import { Tent, Users, GraduationCap, MapPin, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export default function EmbedStats() {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/public/stats").then(({ data }) => setS(data)).catch(() => {});
  }, []);
  const items = [
    { icon: MapPin, label: "Kwarran", value: s ? s.per_kwarran.length : "–" },
    { icon: Users, label: "Peserta Didik", value: s ? s.total_pramuka.toLocaleString("id-ID") : "–" },
    { icon: GraduationCap, label: "Pembina & Pelatih", value: s ? (s.total_pembina + s.total_pelatih).toLocaleString("id-ID") : "–" },
  ];
  return (
    <a href={window.location.origin} target="_top" rel="noreferrer" data-testid="embed-widget"
      className="block m-2 rounded-2xl bg-[#2A1F1B] text-white p-4 shadow-lg hover:shadow-xl transition-shadow">
      <div className="flex items-center gap-2.5 mb-3">
        <div className="h-8 w-8 rounded-lg bg-[#E5A93C] flex items-center justify-center"><Tent className="h-4 w-4 text-[#2A1F1B]" /></div>
        <div className="leading-tight">
          <div className="font-display font-extrabold text-sm">SIPRAM DEPOK</div>
          <div className="text-[10px] uppercase tracking-widest text-white/60 font-bold">Pusat Data Pramuka Kota Depok</div>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <div key={it.label} className="bg-white/10 rounded-xl p-2.5">
              <Icon className="h-3.5 w-3.5 text-[#E5A93C] mb-1" />
              <div className="font-display font-extrabold text-lg leading-none">{it.value}</div>
              <div className="text-[9px] uppercase tracking-wider text-white/60 font-bold mt-1">{it.label}</div>
            </div>
          );
        })}
      </div>
      <div className="mt-3 text-xs font-bold text-[#E5A93C] inline-flex items-center gap-1">Buka Pusat Data <ArrowRight className="h-3 w-3" /></div>
    </a>
  );
}
